export const capitalizeFirstLetters = (string) => {
  if (!string) return ''

  let strCapitalize = string?.toLowerCase()?.replace(/\w\S*/g, (w) => w?.replace(/^\w/, (c) => c?.toUpperCase()))
  return strCapitalize
}
